module.exports = __webpack_public_path__ + "static/media/contact_icon.06a6a020.svg";